const CurveType = {
  HYSTERESIS: 'hysteresis',
  IRM: 'irm',
  BACKFIELD_DEMAGNETIZATION: 'dcd',
  IRM_AND_DCD: 'irm_and_dcd',
  HYSTERESIS_IRM_DCD: 'hysteresis_irm_dcd'
};

export default CurveType;
